var React = require('react');

function Line (props) {
    return React.createElement("svg",props,React.createElement("rect",{"x":"9","y":"11","width":"9","height":"2","rx":"1"}));
}

Line.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Line;

Line.default = Line;
